import { EPrivacyStatus, EUserGender, IUserAuthInfo } from '.';
import { EUserType, UserTypeUtil } from 'shared/models/common';

export interface IUserDetail {
  userId: string;
  avatar: string;
  authInfo: IUserAuthInfo;
  nickName: string;
  linkName: string;
  userType: EUserType;

  gender: EUserGender;
  ageGroup?: number;
  location?: string;

  description: string;

  postCount: number;
  diggCount: number;
  dugCount: number;
  favoriteCount: number;
  favoredCount: number;
  followingCount: number;
  followerCount: number;

  thirdLinks: {
    platform: string;
    name: string;
    url: string;
  }[];

  privacyStatus: EPrivacyStatus;

  isBannedAccount: boolean;
}

export enum EUserUnavailableReason {
  NOT_FOUND = 'not_found',
  SERVER_ERROR = 'server_error',
}

export interface IUserUnavailableDetail {
  userId: string;
  unavailableReason: EUserUnavailableReason;
}

export type TUserDetail = IUserDetail | IUserUnavailableDetail;

export const UserDetailUtil = {
  isUserAvailable: (user: TUserDetail): user is IUserDetail => {
    return !('unavailableReason' in user);
  },
  getPath: (user: IUserDetail): string => {
    const prefix = UserTypeUtil.getLinkNamePrefix(user.userType);

    return `/${prefix}${user.linkName}`;
  },
};
